import { Environment } from "@react-three/drei";
import { Suspense } from "react";

function CanvasEnvironment() {
  return (
    <>
      <Suspense fallback={null}>
        <Environment
          path="./"
          files="./imgs/studio_small_08_1k.hdr"
        ></Environment>
      </Suspense>
    </>
  );
}

export default CanvasEnvironment;
